// extracted by mini-css-extract-plugin
export default {"page":"CWgVzJyzhDb1HMyjx6Y3mQ=="};